<template>
    <el-container>
        <el-header><vHeader></vHeader></el-header>
        <el-container>
            <el-aside :width="isCollapse?'64px':'170px'"><vAside></vAside></el-aside>
            <el-main>
                <vTabView></vTabView>
                <vMain></vMain>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    import vHeader from '@/components/Header'
    import vAside from '@/components/aside'
    import vMain from '@/components/appMain'
    import vTabView from '@/components/tabView'

    export default({
        data(){
            return {}
        },
        components:{
            vHeader,vAside,vMain,vTabView
        },
        computed:{
            isCollapse:function(){
                return this.$store.state.navData.navIsCollapse
            },
        },
        mounted(){

        }
    })
</script>
<style>
    .el-container{
        width: 100%;
        height:100%;
    }
    .el-aside{
        transition:width .3s;
        overflow: visible;
    }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue